import { useEffect, useState } from 'react';

const TerritoryTable = ({ isOpen, onClose, onUserSelect, allUsers, changeManager, selectedDataToChangeManager }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedUserId, setSelectedUserId] = useState('');
  let [selectedUser, setSelectedUser] = useState()
  useEffect(() => {
    if (changeManager) {
      setSelectedUserId(selectedDataToChangeManager?.territory_manager?.id)
      setSelectedUser(allUsers.find(user => user._id === selectedDataToChangeManager?.territory_manager?.id))
    }
  }, [changeManager])

  const filteredUsers = allUsers.filter(user =>
    user.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    let data = allUsers.find(user => user._id === selectedUserId)
    setSelectedUser(data);
  }, [selectedUserId])

  const handleDone = () => {
    onUserSelect && onUserSelect(selectedUser);
    onClose && onClose(false);
  };

  if (!isOpen) return null;

  return (
    <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
      <div className="bg-white rounded shadow-lg p-4" style={{ width: '90%', maxWidth: '800px' }}>
        <div className="mb-3 d-flex align-items-center justify-content-between">
          <div className="position-relative" style={{ width: "50%" }}>
            <i className="bi bi-search position-absolute text-secondary" style={{ top: '12px', left: '12px', fontSize: '18px' }}></i>
            <input
              type="text"
              className="form-control ps-4"
              placeholder="Search Users"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          {selectedUserId &&
            <div>
              <span className="me-2">Selected User: {selectedUser?.firstName + ' ' + selectedUser?.lastName}</span>
            </div>
          }
        </div>

        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th style={{ width: '40px' }}></th>
                <th>User Name</th>
                <th>Role</th>
                <th>Email</th>
                <th>Profile</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((user, index) => (
                <tr key={user._id} style={{ backgroundColor: index % 2 === 0 ? 'white' : '#f9f9f9' }}>
                  <td>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="radio"
                        name="selectedUser"
                        checked={user._id === selectedUserId}
                        onChange={() => setSelectedUserId(user._id)}
                      />
                    </div>
                  </td>
                  <td>{user.firstName + ' ' + user.lastName}</td>
                  <td>{user.role.role_name}</td>
                  <td>{user.email}</td>
                  <td>{user.Profile.profile_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="d-flex justify-content-end mt-3">
          <button className="btn btn-outline-secondary me-2" onClick={() => onClose(false)}>Cancel</button>
          {/* <button className="btn btn-primary" onClick={handleDone}>Done</button> */}
          <button className="btn btn-primary" style={{ backgroundColor: '#007bff', borderColor: '#007bff', color: '#ffffff' }} onClick={() => handleDone()}>Done</button>
        </div>
      </div>
    </div>
  );
};

export default TerritoryTable;
